/**
 * Firebase Configuration
 * TODO: Replace with your actual Firebase project configuration
 * Get these values from Firebase Console > Project Settings > General > Your apps
 */
export const firebaseConfig = {
	apiKey: 'AIzaSyA6cUzVXhuBZEman08pN2d_1WlZBVWrYYU',
	authDomain: 'notify-x-d9e9e.firebaseapp.com',
	projectId: 'notify-x-d9e9e',
	storageBucket: 'notify-x-d9e9e.firebasestorage.app',
	messagingSenderId: '275643017162',
	appId: '1:275643017162:web:25ee9d665c9426297fd133',
};

/**
 * VAPID Key for FCM
 * TODO: Replace with your actual VAPID key
 * Get this from Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
 */
export const vapidKey =
	'BAcPWy8VqGUxaCW5dzel9SETjyM-K_M8TMN3yk4UDp0qC-RvKTlETkm5MGRfLrNMPMPlW0j-hiq_OrEgFU2NhSg';
